import * as Sentry from "@sentry/browser";
import { render } from "react-dom";
import "./setup/ag-grid-license";

import { MESFMain } from "@dexteel/mesf-core";
import "bootstrap/dist/css/bootstrap.css";
import "react-toggle/style.css";
import "./assets/mdb.css";
import "./assets/react-toggle.css";
import "./assets/scroll-bar.css";

import { Provider } from "react-redux";

import {
	CaptureConsole,
	ExtraErrorData,
	HttpClient,
} from "@sentry/integrations";
import { BrowserTracing } from "@sentry/tracing";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import {
	BRAND,
	PAGE_TITLE_TEMPLATE,
} from "./components/shared/title/constants";
import { PageTitleProvider } from "./components/shared/title/page-title-context";
import { TrackModeProvider } from "./providers/track-mode.provider";
import { AuthenticationConfig } from "./setup/auth-config";
import { customConfigurations } from "./setup/configurations";
import { CustomNavbar } from "./setup/navbar";
import "./setup/nprogress";
import { CustomRoutes } from "./setup/routes";
import { store } from "./store";

try {
	if (import.meta.env.VITE_SENTRY_DSN) {
		Sentry.init({
			dsn: import.meta.env.VITE_SENTRY_DSN,
			integrations: [
				new BrowserTracing(),
				new ExtraErrorData(),
				new CaptureConsole({
					levels: ["error"],
				}),
				new HttpClient(),
			],
			tracesSampleRate: 1.0,
		});
	}
} catch (e) {
	console.log("something failed initializing sentry");
}

render(
	<HelmetProvider>
		<PageTitleProvider>
			<Helmet titleTemplate={PAGE_TITLE_TEMPLATE} defaultTitle={BRAND} />
			<Provider store={store}>
				<TrackModeProvider>
					<MESFMain
						routes={CustomRoutes}
						navbar={CustomNavbar}
						authentication={AuthenticationConfig}
						configurations={customConfigurations as any}
					/>
				</TrackModeProvider>
				<Toaster />
			</Provider>
		</PageTitleProvider>
	</HelmetProvider>,
	document.getElementById("root"),
);
